// 部门
export const getCompanyColumns = () => {
  return [
    {
      name: 'deptName',
      columnProps: {
        label: '部门',
        prop: 'deptName',
      },
    },
    {
      name: 'rentalRate',
      columnProps: {
        label: '出租率',
        prop: 'rentalRate',
      },
      columnHeaderTooltip: '租赁中的车辆/全部车辆数*100%',
    },
    {
      name: 'vacancyRate',
      columnProps: {
        label: '空置率',
        prop: 'vacancyRate',
      },
      columnHeaderTooltip: '1-出租率',
    },
    {
      name: 'receivableOverdueRate',
      columnProps: {
        label: '收款逾期率',
        prop: 'receivableOverdueRate',
      },
      columnHeaderTooltip: '逾期剩余应收金额/逾期应收总金额*100%',
    },
    {
      name: 'rentOverdueRate',
      columnProps: {
        label: '欠租率',
        prop: 'rentOverdueRate',
      },
      columnHeaderTooltip: '逾期剩余租金应收金额/逾期应收租金总金额*100%',
    },
  ]
}
